import React, { useState } from "react";
import { ModalWrapper } from "./ModalWrapper";
import { POPUP_STYLES } from "../../constants/popupStyles";

interface TwoFactorSetupModalProps {
  isOpen: boolean;
  onClose: () => void;
  qrCode: string;
  onEnable: (token: string) => void;
  onSkip: () => void;
  error?: string;
}

export const TwoFactorSetupModal: React.FC<TwoFactorSetupModalProps> = ({
  isOpen,
  onClose,
  qrCode,
  onEnable,
  onSkip,
  error,
}) => {
  const [token, setToken] = useState("");

  const handleEnable = () => {
    if (token.trim()) {
      onEnable(token);
      setToken("");
    }
  };

  if (!isOpen) return null;

  return (
    <ModalWrapper
      isOpen={isOpen}
      onClose={onClose}
      title="Setup Two-Factor Authentication"
    >
      <div className="mb-5">
        <p className="text-sm text-[#366A75]/80 mb-4">
          Scan the QR code below with your authenticator app (Google
          Authenticator, Authy, etc.):
        </p>
        <div className="flex justify-center mb-5">
          <img
            src={`data:image/png;base64,${qrCode}`}
            alt="QR Code"
            className="w-48 h-48 border-2 border-[#D0E7E5] rounded-2xl p-2 bg-white"
          />
        </div>
      </div>

      <div className="mb-6">
        <input
          type="text"
          placeholder="Enter 6-digit code"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          maxLength={6}
          className="w-full px-5 py-3.5 bg-[#EBF5F5] rounded-2xl text-[#366A75] placeholder:text-[#9AAFB3] text-base text-center tracking-wider font-mono border border-[#B4D9D4] focus:outline-none focus:ring-2 focus:ring-[#366A75] focus:border-transparent"
        />
        <p className="text-xs text-[#366A75]/70 mt-2 text-center">
          Enter the 6-digit code from your authenticator app
        </p>
        {error && (
          <p className="text-red-600 text-sm font-semibold mt-3 text-center">
            {error}
          </p>
        )}
      </div>

      <div className="flex gap-3 mt-8">
        <button
          onClick={onClose}
          className={`flex-1 ${POPUP_STYLES.button}`}
        >
          Cancel
        </button>
        <button
          onClick={onSkip}
          className={`flex-1 ${POPUP_STYLES.button}`}
        >
          Skip 2FA
        </button>
        <button
          onClick={handleEnable}
          disabled={!token.trim()}
          className={`flex-1 ${POPUP_STYLES.button}`}
        >
          Enable 2FA
        </button>
      </div>
    </ModalWrapper>
  );
};
